/**
 * Stub for the fs/child_process/http2 imports Turbopack pulls into the client graph via
 * @aws-sdk/client-cognito-identity's Node entry. Never executed: those paths are Identity Pool
 * credential resolution, and this app only does Cognito User Pool sign-in (no identityPoolId set).
 */
module.exports = {};
